"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var CheckBox = (function (_super) {
    __extends(CheckBox, _super);
    function CheckBox(props) {
        return _super.call(this, props) || this;
    }
    CheckBox.prototype.render = function () {
        var _a = this.props, id = _a.id, onChange = _a.onChange, json_data = _a.json_data;
        var checked = json_data[id] === "yes";
        return (React.createElement("input", { type: "checkbox", id: id, checked: checked, onChange: function (event) {
                var value = "no";
                if (event.target.checked) {
                    value = "yes";
                }
                onChange(id, value);
            } }));
    };
    return CheckBox;
}(react_1.Component));
exports.CheckBox = CheckBox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tCb3guanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0NoZWNrQm94LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQVUvQjtJQUE4Qiw0QkFBb0I7SUFDOUMsa0JBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBQ00seUJBQU0sR0FBYjtRQUNVLElBQUEsZUFBc0MsRUFBckMsVUFBRSxFQUFFLHNCQUFRLEVBQUUsd0JBQXVCLENBQUE7UUFDNUMsSUFBSSxPQUFPLEdBQVksU0FBUyxDQUFDLEVBQUUsQ0FBQyxLQUFLLEtBQUssQ0FBQTtRQUU5QyxPQUFPLENBQ0gsK0JBQ0ksSUFBSSxFQUFDLFVBQVUsRUFDZixFQUFFLEVBQUUsRUFBRSxFQUNOLE9BQU8sRUFBRSxPQUFPLEVBQ2hCLFFBQVEsRUFBRSxVQUFDLEtBQUs7Z0JBQ1osSUFBSSxLQUFLLEdBQWlCLElBQUksQ0FBQTtnQkFDOUIsSUFBSSxLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sRUFBRTtvQkFDdEIsS0FBSyxHQUFHLEtBQUssQ0FBQTtpQkFDaEI7Z0JBQ0QsUUFBUSxDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQTtZQUN2QixDQUFDLEdBQ0gsQ0FDTCxDQUFBO0lBQ0wsQ0FBQztJQUNMLGVBQUM7QUFBRCxDQUFDLEFBdkJELENBQThCLGlCQUFTLEdBdUJ0QztBQXZCWSw0QkFBUSJ9